module.exports = __webpack_public_path__ + "img/mobile-neck-14_24x414.5074f9c3.png";